function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '..';
import { FakeInput } from './elements';
var func = PropTypes.func,
    number = PropTypes.number,
    string = PropTypes.string;
/**
 * A Counter is a number value that can be updated by two Buttons surrounding the displayed value.
 *
 * @return {jsx}
 */

var Counter = /*#__PURE__*/function (_PureComponent) {
  _inherits(Counter, _PureComponent);

  var _super = _createSuper(Counter);

  function Counter() {
    var _this;

    _classCallCheck(this, Counter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.defaultValue // eslint-disable-line react/destructuring-assignment,

    });

    _defineProperty(_assertThisInitialized(_this), "isControlled", function (prop) {
      var props = _this.props;
      return props.hasOwnProperty(prop);
    });

    _defineProperty(_assertThisInitialized(_this), "getControllableValue", function (key) {
      var props = _this.props;
      var state = _this.state;
      return _this.isControlled(key) ? props[key] : state[key];
    });

    _defineProperty(_assertThisInitialized(_this), "handleIncrementClick", function () {
      var value = _this.getControllableValue('value');

      var _this$props = _this.props,
          step = _this$props.step,
          max = _this$props.max,
          onIncrement = _this$props.onIncrement;
      var nextValue = value + step;

      if (_this.isControlled('value')) {
        nextValue > max ? null : onIncrement(nextValue);
      } else {
        _this.setState({
          value: nextValue > max ? value : nextValue
        }, function () {
          return nextValue > max ? null : onIncrement(nextValue);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDecrementClick", function () {
      var value = _this.getControllableValue('value');

      var _this$props2 = _this.props,
          step = _this$props2.step,
          min = _this$props2.min,
          onDecrement = _this$props2.onDecrement;
      var nextValue = value - step;

      if (_this.isControlled('value')) {
        nextValue < min ? null : onDecrement(nextValue);
      } else {
        _this.setState({
          value: nextValue < min ? value : nextValue
        }, function () {
          return nextValue < min ? null : onDecrement(nextValue);
        });
      }
    });

    return _this;
  }

  _createClass(Counter, [{
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          step = _this$props3.step,
          max = _this$props3.max,
          min = _this$props3.min,
          width = _this$props3.width,
          appearance = _this$props3.appearance;
      var value = this.getControllableValue('value');
      return /*#__PURE__*/React.createElement("div", {
        role: "group",
        className: className,
        tabIndex: "-1",
        step: step,
        max: max,
        min: min,
        width: width
      }, /*#__PURE__*/React.createElement(Button, {
        appearance: appearance,
        onClick: this.handleDecrementClick,
        "data-testid": "decrement"
      }, "-"), /*#__PURE__*/React.createElement(FakeInput, {
        width: width,
        "data-testid": "fakeinput"
      }, value), /*#__PURE__*/React.createElement(Button, {
        appearance: appearance,
        onClick: this.handleIncrementClick,
        "data-testid": "increment"
      }, "+"));
    }
  }]);

  return Counter;
}(PureComponent);
/**
 * PropTypes Validation.
 */


Counter.propTypes = {
  /**
   * Buttons appearance prop customizing the style
   */
  appearance: string,

  /**
   * ClassName needed by styled components
   */
  className: string,

  /**
   * ClassName needed by styled components
   */
  // eslint-disable-next-line react/no-unused-prop-types
  value: number,

  /**
   * Default value of counter. The value is set to 0 if no value is provided by prop
   */
  defaultValue: number,

  /**
   * Maximum value allowed
   */
  max: number,

  /**
   * Minimum value allowed
   */
  min: number,

  /**
   * Callback function called on increment
   */
  onIncrement: func,

  /**
   * Callback function called on decrement
   */
  onDecrement: func,

  /**
   * Step for incrementing/decrementing value
   */
  step: number,

  /**
   * The width of the input
   */
  width: string
};
/**
 * Default props.
 */

Counter.defaultProps = {
  appearance: 'secondary',
  className: '',
  defaultValue: 0,
  max: 1000,
  min: 0,
  onIncrement: function onIncrement() {},
  onDecrement: function onDecrement() {},
  step: 1,
  width: '5rem'
};
export default styled(Counter).withConfig({
  displayName: "Counter",
  componentId: "sc-1xmxfao-0"
})(["display:flex;", "{border-radius:0;font-size:", ";&:first-of-type{border-top-left-radius:", ";border-bottom-left-radius:", ";}&:last-of-type{border-top-right-radius:", ";border-bottom-right-radius:", ";}}"], Button, function (_ref) {
  var fonts = _ref.theme.fonts;
  return fonts.size.h5;
}, function (_ref2) {
  var dimensions = _ref2.theme.dimensions;
  return dimensions.radius;
}, function (_ref3) {
  var dimensions = _ref3.theme.dimensions;
  return dimensions.radius;
}, function (_ref4) {
  var dimensions = _ref4.theme.dimensions;
  return dimensions.radius;
}, function (_ref5) {
  var dimensions = _ref5.theme.dimensions;
  return dimensions.radius;
});